import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-individual-form',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './individual-form.component.html',
  styleUrls: ['./individual-form.component.css'],
})

export class IndividualFormComponent {


  constructor() {}


}
